export default function Footer() {
  return (
    <footer data-testid="main-footer" className="border-t border-white/10 bg-[#060607] px-6 py-20 md:py-28 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <button
          data-testid="footer-logo"
          onClick={() => window.scrollToSection?.("#top")}
          className="flex items-center gap-3 text-left"
        >
          <img src="/logo.png" alt="Club Tuscolana Star Eventi" className="h-16 w-16 rounded-full md:h-20 md:w-20" />
          <span className="font-serif text-4xl tracking-tight text-linen sm:text-6xl md:text-7xl">
            Club Tuscolana <span className="italic text-dusty">Star Eventi</span>
          </span>
        </button>

        <div className="mt-14 grid gap-10 border-t border-white/10 pt-10 text-sm text-linen/50 sm:grid-cols-3">
          <div>
            <p className="mb-3 text-xs uppercase tracking-[0.25em] text-sand">Location</p>
            <p>Via Guido Figliolini 33</p>
            <p>00173 Roma, Italia</p>
          </div>
          <div>
            <p className="mb-3 text-xs uppercase tracking-[0.25em] text-sand">Contatti</p>
            <p>+39 351 313 8542</p>
            <p>clubstareventituscolana@gmail.com</p>
          </div>
          <div>
            <p className="mb-3 text-xs uppercase tracking-[0.25em] text-sand">Eventi</p>
            <p>Matrimoni · Diciottesimi · Cerimonie</p>
            <p>Eventi Aziendali · Compleanni</p>
          </div>
        </div>

        <p className="mt-14 text-xs text-linen/30" data-testid="footer-copyright">
          © {new Date().getFullYear()} Club Tuscolana — Star Eventi. Tutti i diritti riservati.
        </p>
      </div>
    </footer>
  );
}
